"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.usePickupPointsDialog = usePickupPointsDialog;
var _react = require("react");
var _hooks = require("../../hooks");
var _logger = require("../../logger");
var _models = require("../../models");
var _utils = require("../../utils");
const componentName = 'DeliveryOptionsDialog.tsx';
// TODO: Check what the point of this is
/** Helper hook for pickup points dialog toggling, including some analytics. */ function usePickupPointsDialog() {
    const [isFindPickupPointsOpen, setIsFindPickupPointsOpen] = (0, _react.useState)(false);
    const { isAddingNewDelivery } = (0, _hooks.useAnalytics)();
    const togglePickupPointsDialog = (0, _react.useCallback)(()=>{
        setIsFindPickupPointsOpen((prevState)=>{
            const isOpen = !prevState;
            (0, _logger.logDebug)("".concat(componentName, ": setIsFindPickupPointsOpen(").concat(isOpen, ") called."));
            // analytics
            if (isOpen) {
                (0, _utils.dispatchUserActionEvent)([
                    _models.MetaHierarchy.DeliverySelection,
                    isAddingNewDelivery.current ? _models.MetaHierarchy.FirstSelection : _models.MetaHierarchy.EditSelection,
                    _models.MetaHierarchy.New,
                    _models.MetaHierarchy.PickUpPoint,
                    _models.MetaHierarchy.PickUpPointOpen
                ]);
            }
            return isOpen;
        });
    }, [
        isAddingNewDelivery
    ]);
    return {
        isFindPickupPointsOpen,
        togglePickupPointsDialog
    };
}
